import _ from "lodash";
import { InputField, ReactSelect, required, ToggleField } from "modules/4_final_form/web";
import toSentence from "modules/5_view_helpers/to_sentence";
import BasicModal from "modules/5_view_helpers/web/BasicModal";
import React, { useEffect } from "react";
import { Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Button, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Label } from "reactstrap";

import { getProjects } from "modules/projects/actions";
import { connect } from "react-redux";
import { getEmployees } from "modules/employees/actions";

function mapStateToProps(state) {
  return {
    projects: state.projects,
    employees: state.employees,
  };
}

const ConditionsAttributes = (props) => {
  const { fields, labels, inputs, projects,employees } = props;

  const removeCondition = (index) => {
    const thisValues = fields.value[index];

    if (thisValues.id) {
      fields.update(index, {
        ...thisValues,
        _destroy: true,
      });
    } else {
      fields.remove(index);
    }
  };

  return (
    <div>
      <b>Conditions (AND) </b>

      <Button
        onClick={() => {
          fields.forEach((field, index) => {
            fields.update(index, {
              ...fields.value[index],
              open: false,
            });
          });

          fields.push({
            open: true,
          });
        }}
        className="ml-2"
        size="sm"
      >
        Add Condition
      </Button>

      {fields.map((field, index) => {
        const thisValues = fields.value[index];
        if (thisValues._destroy) return null;

        return (
          <ConditionFields
            field={field}
            key={index}
            fields={fields}
            index={index}
            values={thisValues}
            inputs={inputs}
            removeCondition={() => {
              removeCondition(index);
            }}
            getEmployees={props.getEmployees}
            projects={projects}
            employees={employees}
          />
        );
      })}

      {_.isEmpty(fields.value) && _.isNotEmpty(labels) && (
        <div className="mt-2">No conditions - The below actions will be on any {toSentence(labels)}</div>
      )}
      {_.isEmpty(fields.value) && _.isEmpty(labels) && (
        <div className="mt-2">No conditions which means the actions will not be active until you seelct an above toggle</div>
      )}
    </div>
  );
};

export default connect(mapStateToProps, { getProjects, getEmployees })(ConditionsAttributes);

const ConditionFields = (props) => {
  const { field, index, values, removeCondition, fields, inputs, projects, employees } = props;
  const { open, field_name, operator, value, select_value, boolean_value, project_id } = values;

  const toggle = () => {
    fields.update(index, {
      ...fields.value[index],
      open: !open,
    });
  };

  const selectedInput = _.find(inputs, (i) => i.name == field_name);
  const isSelect = selectedInput && (selectedInput.column_type == "select" || selectedInput.column_type == "multiselect");
  const isToggle = selectedInput && selectedInput.column_type == "toggle";
  const isYesNoNa = selectedInput && selectedInput.column_type == "yesnona";
  const isProject = selectedInput && selectedInput.column_type == "project";
  const isEmployee = selectedInput && selectedInput.column_type == "employee";

  useEffect(() => {
    if (isEmployee) {
      props.getEmployees();
    }
  }, [isEmployee]);


  let valueLabel = "anything";
  if (isSelect || isYesNoNa) {
    if (_.isEmpty(select_value)) {
      valueLabel = "anything";
    } else {
      valueLabel = toSentence(_.map(select_value, "value"), { twoWordsConnector: " OR " });
    }
  } else if (isToggle) {
    valueLabel = boolean_value ? "TRUE" : "FALSE";
  } else if (isProject) {
    valueLabel = _.find(projects, (p) => p.id == project_id)?.display_name;
  } else {
    if (value) {
      valueLabel = value;
    }
  }

  const label = `${field_name} ${operator} ${valueLabel}`;

  return (
    <Card className="mt-2">
      <CardHeader
        onClick={toggle}
        style={{
          cursor: "pointer",
        }}
      >
        <Col>{label || "New Condition"}</Col>
        <Col>
          <BasicModal
            buttonLabel="Remove Condition"
            buttonColor="danger"
            successButtonLabel="Yes"
            onSuccessClick={() => {
              removeCondition(index);
            }}
            title={`Remove Condition`}
          >
            Are you sure you want to remove this Condition?
          </BasicModal>
        </Col>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody>
          <FormGroup row>
            <Label md={2}>Field</Label>
            <Col md={10}>
              <Field
                component={ReactSelect}
                name={`${field}.field_name`}
                options={_.map(inputs, (i) => {
                  return { label: i.label, value: i.name };
                })}
                validate={required}
                parse={(value) => value}
              />
            </Col>
            <OnChange name={`${field}.field_name`}>
              {(value, previous) => {
                fields.update(index, {
                  ...fields.value[index],
                  field_type: selectedInput.column_type,
                });
              }}
            </OnChange>
          </FormGroup>
          <FormGroup row>
            <Label md={2}>Operator</Label>
            <Col md={10}>
              <Field component={ReactSelect} name={`${field}.operator`} options={[{ label: "=", value: "=" }]} validate={required} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={2}>Value {!isToggle && <span>Leave blank for the field just being present</span>}</Label>
            <Col md={10}>
              {isSelect && (
                <Field
                  component={ReactSelect}
                  name={`${field}.select_value`}
                  multi
                  options={_.map(selectedInput?.options, (o) => ({ label: o.value, value: o.value }))}
                  parse={(value) => (_.isArray(value) ? value : [])}
                />
              )}
              {isYesNoNa && (
                <Field
                  component={ReactSelect}
                  name={`${field}.select_value`}
                  multi
                  options={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                    { label: "N/A", value: "N/A" },
                  ]}
                  parse={(value) => (_.isArray(value) ? value : [])}
                />
              )}
              {isToggle && <Field component={ToggleField} name={`${field}.boolean_value`} />}
              {isProject && (
                <Field
                  component={ReactSelect}
                  name={`${field}.project_id`}
                  options={_.map(projects, (p) => ({ label: p.display_name, value: p.id }))}
                />
              )}
              {isEmployee && (
                <Field
                  component={ReactSelect}
                  name={`${field}.employee_id`}
                  options={_.map(employees, (p) => ({ label: p.display_name, value: p.id }))}
                  placeholder="Select Employee"
                  validate={required}
                />
              )}
              {!isSelect && !isToggle && !isYesNoNa && !isProject && !isEmployee && (
                <Field component={InputField} name={`${field}.value`} parse={(v) => v} />
              )}
            </Col>
          </FormGroup>
        </CardBody>
      </Collapse>
    </Card>
  );
};
